export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImU5NGFjZjBkLTMwNDMtNDdjMi1iY2NkLTMwM2I5ZjIyM2Q1NiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.CyENtWFcSHsPWp5yRVG/ufTS7X7zeJJqXgss4yON0gbR1OWYb+Kojpv0sXJF3VL0AXluOoiHczPgpDtr28a1k8SfsAQCimdFNgK2+alT7VOHt+4KyQmHoFPBsZ7hxgTw9HaDgg=='
